(ns pfo.activity.model (:require [pfo.api :as api]
                             [pfo.util :as util]))

(defn collection-activity [{collection-id :collection-id
                            include-subcollections :include-subcollections
                            page :page
                            :as options}]
  (api/ajaxp (str "/activity/collection/?" (util/make-params
                                             (util/remove-nil-values
                                               {:collection_id collection-id
                                                :include_subcollections include-subcollections
                                                :page page}))) {}))

(defn user-activity [page]
  (api/ajaxp "/activity/user/" {:params (util/remove-nil-values {:page page})}))
